import { render, staticRenderFns } from "./EditorMenuBtn.vue?vue&type=template&id=c4d55ea6&scoped=true&"
import script from "./EditorMenuBtn.vue?vue&type=script&lang=js&"
export * from "./EditorMenuBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d55ea6",
  null
  
)

export default component.exports